import React, { useEffect, useState } from 'react';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import Currency from '../../../shared/components/Currency';
import Styled from './styles';
import { useTranslation } from 'react-i18next';
import { useInjection } from 'inversify-react';
import type { IStandingTicketsEvents } from '../../../lib/widget_announcements/standingTickets/standingTickets.events';
import { STANDING_TICKETS_MODULE_IDS } from '../../../lib/widget_announcements/standingTickets/standingTickets.const';
import { IStandingTicketController } from '../../../lib/widget_announcements/standingTickets/standingTicket.interface';
import { priceFormatter } from '../../../helpers/formatters';
import COLORS from '../../../constants/COLORS';

type StandingTicketsFooterProps = {
  sector: string;
};

export const StandingTicketsFooter: React.FC<StandingTicketsFooterProps> = (props) => {
  const { sector } = props;
  const { t } = useTranslation();
  const standingTicketsEvents: IStandingTicketsEvents = useInjection(
    STANDING_TICKETS_MODULE_IDS.STANDING_TICKETS_EVENTS,
  );
  const standingTicketsController: IStandingTicketController = useInjection(
    STANDING_TICKETS_MODULE_IDS.STANDING_TICKETS_CONTROLLER,
  );
  const [price, setPrice] = useState(standingTicketsController.totalSumBySectors[sector] || 0);

  const setTotal = () => {
    setPrice(standingTicketsController.totalSumBySectors[sector]);
  };

  useEffect(() => {
    standingTicketsController.addListener(standingTicketsEvents.UPDATE_TOTAL, setTotal);

    return () => {
      standingTicketsController.removeListener(standingTicketsEvents.UPDATE_TOTAL, setTotal);
    };
  }, []);

  return (
    <Styled.Footer>
      {t('total')}
      <Styled.Price dark={!!price}>
        <Currency>
          {priceFormatter(price)}{' '}
          <CurrencyIcon
            width={9}
            height={10}
            fill={(price && COLORS.MARKETPLACE_BLACK) || COLORS.MARKETPLACE_DARK_GREY}
          />
        </Currency>
      </Styled.Price>
    </Styled.Footer>
  );
};
